import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changeArea } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { ICreateArea } from "src/Pages/Company/OrganizationStructure/Areas/Area.models";

const useChangeArea = (
  companyId: string,
  structureId: string,
  areaId: string,
  exitEditMode: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: ICreateArea) =>
      changeArea(companyId, structureId, areaId, formData),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie zapisano dane"), "success");
      queryClient.invalidateQueries({
        queryKey: ["area-data", companyId, structureId, areaId],
      });
      exitEditMode();
    },
  });
};

export default useChangeArea;
